import { AxiosResponse } from "axios";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";
import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";

function* fetchInsituExtractorListSaga(action: types.FetchInsituExtractorListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IInsituExtractorList | types.IApiError> = yield call(services.getInsituExtractorList, action.params);
        if (response.status === 200) {
            yield put(
                actions.fetchExtractorListSuccess({
                    insituExtractors: response.data as types.IInsituExtractorList,
                })
            );
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }
    } catch (e: any) {
        yield put(
            actions.fetchInsituExtractorListFailure({
                error: e,
            })
        );
    }
}
function* fetchInsituExtractorDetailsSaga(action: types.FetchInsituExtractorDetailsReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IInsituExtractorDetails | types.IApiError> = yield call(services.getInsituExtractorDetail, action.params);
        if (response.status === 200) {
            yield put(
                actions.fetchInsituExtractorDetailsSuccess({
                    insituExtractor: response.data as types.IInsituExtractorDetails,
                })
            );
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }
    } catch (e: any) {
        yield put(
            actions.fetchInsituExtractorDetailsFailure({
                error: e,
            })
        );
    }
}

function* postInsituExtractorSaga({ payload }: types.PostInsituExtractorRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        // yield put(alert.enqueueSnackbar({ message: `Insitu extractor in progress, Timestamp: ${timestamp}`, options: { variant: "success" } }));
        const response: AxiosResponse<types.IPostInsituExtractorSuccess | types.IApiError> = yield call(services.postInsituExtractor, payload);

        if (response.status === 200) {
            let dataPayload = response.data as types.IPostInsituExtractorSuccess;
            yield put(
                actions.postInsituExtractorSuccess({
                    insituExtractor: dataPayload
                })
            );
            if (dataPayload.id) {
                yield put(alert.enqueueSnackbar({ message: `Insitu extractor created successfully. Batch Code: ${dataPayload.datasetName}, Id: ${dataPayload.id},Timestamp: ${timestamp}`, options: { variant: "success" } }));

            }
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(
                alert.enqueueSnackbar({
                    message: errmsg,
                    options: { variant: "error" },
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postInsituExtractorFailure({
                error: e.message,
            })
        );
    }
}

function* putInsituExtractorSaga({ insituId, payload }: types.PutInsituExtractorRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        yield put(alert.enqueueSnackbar({ message: `Insitu extractor in progress, Timestamp: ${timestamp}`, options: { variant: "success" } }));
        const response: AxiosResponse<types.IInsituExtractorPutSuccess | types.IApiError> = yield call(services.putInsituExtractor, insituId, payload);

        if (response.status === 200) {
            let dataPayload = response.data as types.IInsituExtractorPutSuccess;
            yield put(
                actions.putInsituExtractorSuccess({
                    insituExtractorStatus: dataPayload,
                })
            );
            if (dataPayload.id) {
                yield put(alert.enqueueSnackbar({ message: `Insitu extractor updated successfully. Batch Code: ${dataPayload.datasetName}, Id: ${dataPayload.id},Timestamp: ${timestamp}`, options: { variant: "success" } }));

            }
        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(
                alert.enqueueSnackbar({
                    message: errmsg,
                    options: { variant: "error" },
                })
            );
            yield put(
                actions.postInsituExtractorFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postInsituExtractorFailure({
                error: e.message,
            })
        );
    }
}

function* deleteInsituExtractorSaga(action: types.DeleteInsituExtractorRequest) {
    const timestamp = new Date().toLocaleString();

    try {
        const response: AxiosResponse<types.IDeleteInsituExtractorSuccess[] | types.IApiError> = yield call(services.deleteInsituExtractor, action.payload);
        if (response.status === 200) {
            let dataPayload = response.data as types.IDeleteInsituExtractorSuccess[];
            yield put(
                actions.deleteInsituExtractorSuccess({
                    deleteStatus: dataPayload
                })
            );

            yield put(alert.enqueueSnackbar({ message: `The Insitu Criticality was successfully deleted, Timestamp: ${timestamp}.`, options: { variant: "success" } }))

        }

        //Show IApiError
        if (response.status !== 200) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}, Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: errmsg, options: { variant: "error" } }));
        }

    } catch (e: any) {
        yield put(
            actions.deleteInsituExtractorFailure({
                error: e,
            })
        );
    }
}

function* insituExtractorPutSaga() {
    yield takeLatest(actionTypes.PUT_INSITU_EXTRACTOR_REQUEST, putInsituExtractorSaga);
}
function* insituExtractorListSaga() {
    yield takeLatest(actionTypes.FETCH_INSITU_EXTRACTOR_LIST_REQUEST, fetchInsituExtractorListSaga);
}
function* insituExtractorDetailsSaga() {
    yield takeEvery(actionTypes.FETCH_INSITU_EXTRACTOR_DETAILS_REQUEST, fetchInsituExtractorDetailsSaga);
}

function* insituExtractorPostSaga() {
    yield takeLatest(actionTypes.POST_INSITU_EXTRACTOR_REQUEST, postInsituExtractorSaga);
}

function* getDeleteInsituExtractorSaga() {
    yield takeEvery(actionTypes.DELETE_INSITU_EXTRACTOR_REQUEST, deleteInsituExtractorSaga);
}
function* insituSaga() {
    yield all([
        insituExtractorListSaga(),
        insituExtractorDetailsSaga(),
        insituExtractorPostSaga(),
        insituExtractorPutSaga(),
        getDeleteInsituExtractorSaga()
    ])
}

export default insituSaga;